module.exports = __webpack_public_path__ + "static/amex-booth-72a0821396e304007b2316535f0febd8.jpg";